



















import {Component, Prop, Vue} from "vue-property-decorator";
import {Helpers} from "@/Helpers";

@Component
export default class StringArrayForm<T = unknown> extends Vue {
    @Prop() public readonly label!: string;
    @Prop() public readonly hint?: string;
    @Prop() public readonly value!: T[];
    @Prop({default: (): T[] => []}) public readonly items!: T[];
    @Prop() public readonly rules?: [];

    get array(): T[] {
        return this.value;
    }

    set array(val: T[]) {
        this.value.splice(0);

        if (this.items.length > 0) {
            val = val.filter(i => Helpers.isInArray<T>(i, this.items));
        }

        this.value.push(...val);
    }
}
